var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 12.5C16.6742 12.4458 19.1667 9.9725 19.1667 6.66667C19.1667 4.15667 18.3358 4.9875 17.5 5.83333C16.6742 6.65 15 8.33333 15 8.33333L11.6667 5C11.6667 5 13.35 3.32583 14.1667 2.5C15.0125 1.66417 15.0125 0.833334 13.3333 0.833334C10.0275 0.833334 7.54417 3.32583 7.5 6.66667C7.535 7.48 7.5 9.16667 7.5 9.16667C5.92917 10.7475 3.88333 12.7942 2.5 14.1667C0.0566661 16.62 3.38 19.9433 5.83333 17.5C7.20833 16.115 9.26083 14.0625 10.8333 12.5C10.8333 12.5 12.52 12.465 13.3333 12.5Z",
    stroke: "white",
    strokeWidth: 1.66667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigIcon);
export default __webpack_public_path__ + "static/media/config_icon.e14b6ecaf5d4548dbe9ad010cc3ab746.svg";
export { ForwardRef as ReactComponent };